import React from 'react';
import { EvidenceChip } from '../../design/primitives';

export type EvidenceTier = 'confirmed' | 'emerging' | 'unconfirmed';

export function AgedChip({ days }: { days?: number | null }) {
  return <EvidenceChip tone="weakened" size="small" label="aged" data-testid="aged-chip"
    title={`past its ${days ? `${days}-day` : 'source'} evidence window; re-confirm to restore`}
    sx={{ height: 18, fontSize: '0.62rem', ml: 0.5 }} />;
}

/** The tier a driver or suggestion EARNED (#185): confirmed · emerging · unconfirmed. Server-assigned, never inferred here. */
export default function TierChip({ tier, size = 'small', aged = false, decayDays }: { aged?: boolean; decayDays?: number | null; tier: EvidenceTier | string | null | undefined; size?: 'small' | 'medium' }) {
  const t = (tier === 'confirmed' || tier === 'emerging' ? tier : 'unconfirmed') as EvidenceTier;
  return (
    <><EvidenceChip
      tone={t}
      label={t.toUpperCase()}
      size={size}
      data-testid="tier-chip"
      data-tier={t}
      sx={{ height: 18, fontSize: '0.62rem' }}
    />{aged && <AgedChip days={decayDays} />}</>
  );
}
